export function getLiveViewerCount(stream) {
  if (!stream) return "";
  return stream.liveViewers || stream.viewers || "";
}
